import { LanguagesApiDTO } from './languages.dto';
import { LanguageRepo } from './language.repo';
import { BaseApiService } from '@shared/services/apiService/base-api.service';
import { firstValueFrom } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';

export function languageFactory(apiService: BaseApiService<LanguagesApiDTO>,
                                repo: LanguageRepo) {
  return async () => {
    try {
      const response = await firstValueFrom(apiService.withHeader(
        new HttpHeaders({
          Authorization: `Bearer ${environment.config_token}`,
          'X-Skip-Interceptor': '',
        }),
      ).get());
      repo.setLanguages(response ?? []);
    } catch (error) {
      console.error(' > LanguageFactory | Error getting languages from db: ', error);
      throw error;
    }
  };
}
